module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingReceiverClassroom"
    }
  }, [(_vm.reschedulingInfo.receiver.id !== _vm.$store.state.userInfo.user_id) ? _c('div', {
    key: "unauthorized"
  }, [_vm._m(0)]) : (_vm.reschedulingInfo.status !== 'pending') ? _c('div', {
    key: "got-result"
  }, [_vm._m(1)]) : _c('div', {
    key: "receiver-classroom"
  }, [_c('section', [_c('h1', [_vm._v("座席選択ページ")]), _vm._v(" "), _c('div', {
    staticClass: "Info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("選択された振替日時")]), _vm._v(" "), _c('div', {
    staticClass: "Info-data"
  }, [_c('p', [_vm._v("日付：　" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.rescheduled_reservation.date)))]), _vm._v(" "), _c('p', [_vm._v("時間：　" + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.start_time) + " 〜 " + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.end_time) + "の１コマ")])])])]), _vm._v(" "), _c('section', [_c('h1', [_vm._v("その時間の空き教室状況")]), _vm._v(" "), _c('p', [_vm._v("座席を一つ選択してください")]), _vm._v(" "), _c('div', {
    staticClass: "classroom_List"
  }, _vm._l((_vm.classrooms), function(classroom) {
    return _c('ul', {
      staticClass: "list"
    }, [_c('label', [_c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (classroom.name != 'prohibited'),
        expression: "classroom.name != 'prohibited'"
      }],
      staticClass: "content"
    }, [_c('input', {
      attrs: {
        "name": "classroom",
        "type": "radio"
      },
      on: {
        "change": function($event) {
          _vm.selectedclassroom(classroom.name)
        }
      }
    }), _vm._v("\n            " + _vm._s(classroom.name) + "\n          ")])])])
  }))]), _vm._v(" "), _c('div', [_c('p', [_c('span', {
    staticClass: "errormessage"
  }, [_vm._v(_vm._s(_vm.errormessage))])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.cancelButtonClicked()
      }
    }
  }, [_c('span', [_vm._v("\n        戻って修正する\n      ")])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.onConfirmButtonClicked()
      }
    }
  }, [_c('span', [_vm._v("\n        座席を確定する\n      ")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替情報を表示する権限がありません")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報は承認または非承認しております")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f11f081", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f11f081"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/ReschedulingPage/SpReceiverClassroom.vue
// module id = 682
// module chunks = 0